import { APP_ENV, Environment } from '../environments';

const ENV_TO_HOYA_COMPANY_ID_MAP = {
    [ Environment.QA ]: 'f079d7a1-7a56-46c7-ad2d-88134d1b4a5d',
    [ Environment.PPRD ]: '5caf0024-0b69-419f-b233-b3797df18864',
    [ Environment.PROD ]: 'd0cd644b-4691-412d-83d1-0fa0952a6050',
};

/**
 * The default company ID to fallback to using if a proper company ID can't be
 * used or found for some reason.
 * @type { string }
 */
const HOYA_DEFAULT_COMPANY_ID = ENV_TO_HOYA_COMPANY_ID_MAP[ Environment.QA ];

/**
 * The ID of the company in Nackle matching the environment the site is currently
 * running in.
 * @type { string }
 */
export const HOYA_COMPANY_ID = ENV_TO_HOYA_COMPANY_ID_MAP[ APP_ENV ] || HOYA_DEFAULT_COMPANY_ID;
